var map = {
	"./icon_group.png": 50109,
	"./new_icon.svg": 12777,
	"./sidebar_buyisp.svg": 10721,
	"./sidebar_buyisp_act.svg": 70081,
	"./sidebar_buyresi.svg": 79972,
	"./sidebar_buyresi_act.svg": 55232,
	"./sidebar_contact.svg": 97573,
	"./sidebar_contact_act.svg": 1033,
	"./sidebar_datacenter.svg": 37432,
	"./sidebar_deposit.svg": 99934,
	"./sidebar_deposit_act.svg": 38895,
	"./sidebar_getproxy.svg": 74792,
	"./sidebar_getproxy_act.svg": 4814,
	"./sidebar_helpcenter.svg": 88302,
	"./sidebar_helpcenter_act.svg": 67333,
	"./sidebar_ipmgr.svg": 51645,
	"./sidebar_ipmgr_act.svg": 10753,
	"./sidebar_isporders.svg": 59906,
	"./sidebar_isporders_act.svg": 63330,
	"./sidebar_overview.svg": 64032,
	"./sidebar_overview_act.svg": 25037,
	"./sidebar_resiorders.svg": 10125,
	"./sidebar_resiorders_act.svg": 55075,
	"./sidebar_usage.svg": 11545,
	"./sidebar_usage_act.svg": 63293,
	"./sidebar_wallet.svg": 13548,
	"./sidebar_wallet_act.svg": 63958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16523;